$(document).ready(function(){ 
  $("#menu-toggler, a.closeme-flyout, .fader-bg").click(function(){
  	clickMobileMenu();
  });
  $(".sidebar-slideout-trigger").click(function(){
    clickMobileSubMenu(this);
  });
    $(".sidebar-slidein-trigger").click(function(){
    closeMobileSubMenu(this);
  });
  $(".sidebar-item-dropdown").click(function(event){
    if ($(this).hasClass("active")) {event.preventDefault();}
    $(this).parent().toggleClass("active");
    $(this).toggleClass("active");
  });
  
  $(".readmore-desc").click(function(e){
    e.preventDefault();
    $(".full-desc, .starter-desc").toggle();
    $(this).hide();
  });
  
  $(".faq-box").click(function(){
  	$(this).toggleClass("active");
  });
  
  $("#pagination_select").change(function(event){
    var viewVar = $(event.target).children("option:selected").val();
    window.location.href = updatePaginationUrl(viewVar);
  });

  $(".m-placeholder").on("change", "select", psuedoPlaceholderToggle);

  function psuedoPlaceholderToggle() {
    var dropdownEl = this;
    var labelEl = this.parentNode.querySelector('label');
    
    if (dropdownEl.value != "") {
      labelEl.style.display = 'none';
    } else {
      labelEl.style.display = '';
    }
  }
  
  function addParams( url, data ) {
    if ( ! $.isEmptyObject(data) ) {
      url += ( url.indexOf('?') >= 0 ? '&' : '?' ) + $.param(data);
    }
    return url;
  }
  
  function updatePaginationUrl(paginateBy) {
    currentURL = window.location.href.replace(/&?view=([^&]$|[^&]*)/i, "").replace(/&?page=([^&]$|[^&]*)/i, "");
    return addParams(currentURL, {view: paginateBy});
  }
  
  function clickMobileMenu(){
    $slideOutMenu = $("nav.mobile");
    $faderBG = $('.fader-bg');
    if ($slideOutMenu.hasClass("active")) {
      $faderBG.fadeOut();
      $slideOutMenu.animate({
          left: "-280px"
        }, 600, function() {
          $slideOutMenu.toggleClass("active");
          closeMobileSubMenus();
      });
    } else {
      $faderBG.fadeIn();
      $slideOutMenu.animate({
          left: "0px"
        }, 600, function() {
          $slideOutMenu.toggleClass("active");
      });
    }
  }
  
  function clickMobileSubMenu(that){
    $slideOutMenu = $(that).next('.mobile-slideout');
    $slideOutMenu.animate({
        left: "0px"
      }, 600, function() {
        $slideOutMenu.toggleClass("active");
    });
  }
  
  function closeMobileSubMenus() {
    $(".mobile-slideout").css({"left": "-280px"});
  }
  
  function closeMobileSubMenu(that) {
    $this = $(that); 
    $slideOutMenu = $(that).parent('.mobile-slideout');
    
    $slideOutMenu.animate({
      left: "-280px"
    }, 600, function() {
      $slideOutMenu.toggleClass("active");
    });
  }
  
  function addItem(form_id) {
    
    $("#add-to-cart").prop("disabled",true);
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#'+form_id).serialize(),
      success: Shopify.onSuccess,
      error: Shopify.onError
    });
  }

  $('.addtocart').click(function(e) {
    e.preventDefault();
    //$(this).prop('disabled', true);
    addItem('add-item-form');
  });   

  Shopify.onSuccess = function() {
    //____020
    //alert('okz');
    
    $.getJSON('/cart.js', function(cart) {
    // Update cart count
    $('.c_count').html(' ('+cart.item_count+')');
  });
    fetchCart();
    
    
    
    

    
    setTimeout(
  function() 
  {
    $lateral_cart2 = $('#cd-cart');
	$shadow_layer2 = $('#cd-shadow-layer');
    toggle_panel_visibility($lateral_cart2, $shadow_layer2, $('body'));    
    //-
    $("#add-to-cart").prop("disabled",false);
  }, 1000);
    
    
    return false;
    
    /**/
    
    $.fancybox.open([{href: "#cart-success"}]);
    
    
  };

  Shopify.onError = function(XMLHttpRequest, textStatus) {
    // Shopify returns a description of the error in XMLHttpRequest.responseText.
    // It is JSON.
    // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      alert(data.message + '(' + data.status  + '): ' + data.description);
    } else {
      alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
    }

    $('.addtocart').removeAttr("disabled");
  };

  Shopify.fullMessagesFromErrors = function(errors) {
    var fullMessages = [];
    jQuery.each(errors, function(attribute, messages) {
      jQuery.each(messages, function(index, message) {
        fullMessages.push(attribute + ' ' + message);
      });
    });
    return fullMessages;
  };

  if ($(".owl-products-carousel").length != 0) {  
    $(".owl-products-carousel").owlCarousel({
      loop: true,
      nav: true,
      navText: ["",""],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 3
        },
        992: {
          items: 5
        }
      }
    });
  }
  
  if ($(".recommended-items.recommended-owl").length != 0) {  
    $(".recommended-items.recommended-owl").owlCarousel({
      loop: true,
      nav: true,
      navText: ["",""],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 3
        },
        992: {
          items: 5
        }
      }
    });
  }
  
  if ($(".featured_products_slider").length != 0) {  
    $(".featured_products_slider").owlCarousel({
      loop: true,
      nav: true,
      margin:20,
      navText: ["",""],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        }
      }
    });
  }
  
  
  //__020

  var retail_login_link = document.querySelector('.horizontal li a#customer_login_link');
  if (retail_login_link) {
    retail_login_link.addEventListener("click", function() {
      window.localStorage.removeItem("wholesale-login");
      console.log('retail login clicked');
    });
  };

  //restrict quantity inputs to number available
  $(document).on('keyup', 'input[name=quantity], input[name="updates[]"]', function() {
    var _this = $(this);
    var min = parseInt(_this.attr('min')) || 1; // if min attribute is not defined, 1 is default
    var max = parseInt(_this.attr('max')) || 10000; // if max attribute is not defined, 10000 is default
    var val = parseInt(_this.val()) || (min - 1); // if input char is not a number the value will be (min - 1) so first condition will be true
    if (val < min)
      _this.val(min);
    if (val > max)
      _this.val(max);
  });

});

jQuery(window).load(function(){

  if ( $('.slides li').length > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });

});

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).attr('src', newImageSrc);
  
    $(mainImageDomEl).parents('a').attr('href', newImageSrc);
  
};


jQuery(document).ready(function($){

  var $aZoom = $("a.zoom"),
      $previewPopup = $(".preview-popup");

  if ($aZoom.length) {
    $aZoom.fancybox({
      padding:0,
      closeBtn : true,
      'titleShow': false,
      overlayColor: '#000000',
      overlayOpacity: 0.2
    });
  }
  
  if ($previewPopup.length) {
    $previewPopup.fancybox({
      width: '1200',
      padding:20,
      'titleShow': false,
      closeBtn : true,
      overlayColor: '#000000',
      overlayOpacity: 0.2,
      beforeShow: function() {
        switchImage($(this.element).attr('data-original-image'), null, $('.featured img')[0]);
      }
    });
  }
  
  $(".click-for-fancybox").click(function(){ $("#firstImage").click(); });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#product-popup .thumbs a').on('click', function(e) {
    e.preventDefault();
    $("#product-popup .thumbs .image").removeClass("active");
    switchImage($(this).attr('href'), null, $('.featured img')[0]);
    $(this).parent('.image').addClass("active");
  } );

  

  $(".flyout").hide();

  $("#menu-toggle").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };

})(jQuery);
